window.addEventListener('load', function () {
  const detailElements = document.querySelectorAll('[data-js-accordion] details')

  setDetailsHeight('details')

  function setDetailsHeight (selector, wrapper = document) {
    const setHeight = (detail, open = false) => {
      detail.open = open
      const rect = detail.getBoundingClientRect()
      detail.style.setProperty(open ? '--expanded' : '--collapsed', `${rect.height}px`)
    }
    const details = wrapper.querySelectorAll(selector)
    const RO = new ResizeObserver(entries => {
      return entries.forEach(entry => {
        const detail = entry.target

        if (!detail.open) {
          detail.removeAttribute('style')
          setHeight(detail)
          setHeight(detail, true)
          detail.open = false
        }
      })
    })
    details.forEach(detail => {
      RO.observe(detail)
    })
  }

  detailElements
    .forEach(details => details.addEventListener('toggle', detailsToggler))

  function detailsToggler (event) {
    if (!event.target.open) return
    const container = event.target.closest('.accordion')
    const openDetails = [...container.querySelectorAll('details[open]')]
      .filter(details => details !== event.target)

    if (!openDetails.length) return

    const summary = event.target.querySelector('summary')
    const top = summary.getBoundingClientRect().top

    openDetails.forEach(details => { details.open = false })
    keepPosition(summary, top)
  }

  // Gleicht die Scrollposition aus, solange darüberliegende Items zuklappen
  function keepPosition (element, top) {
    const duration = parseFloat(window.getComputedStyle(element.parentElement).transitionDuration) * 1000
    const end = window.performance.now() + duration + 100

    const correct = (now) => {
      const offset = element.getBoundingClientRect().top - top
      if (offset) window.scrollBy({ top: offset, behavior: 'instant' })
      if (now < end) window.requestAnimationFrame(correct)
    }

    correct(window.performance.now())
  }

  function openFromHash () {
    const id = decodeURIComponent(window.location.hash.slice(1))
    const target = id && document.getElementById(id)
    const details = target && target.closest('[data-js-accordion] details')

    if (!details) return

    details.open = true
    target.scrollIntoView({ behavior: 'instant' })
  }

  openFromHash()
  window.addEventListener('hashchange', openFromHash)
})
